import { useState } from 'preact/hooks';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Global/Icon';
import { updateInsuranceAction } from '../../actions/UserData';
import Text from '../Global/Text';
import Label from '../Form/Label';
import { getProductPrice } from '../../utilities/combined-common';

export const Multiproduct = ({
  priceDetails,
  priceTitle,
  options,
  dispatch,
  userData,
  title,
  priceBreakActions,
  setValues,
  values,
  combinedPrice,
  commonFees,
  bsFees
}) => {
  const allItems = options;
  const initialCheckedState = allItems.map(item => userData.basketList?.includes(item.name) ?? false);
  const [checkedState, setCheckedState] = useState(initialCheckedState);
  const [initialCost, setTotalCost] = useState(userData.initialCost ?? 0);
  
  const getPrice = (product) => {
    let price = getProductPrice(product, userData);
    return price;
  }
  const handleOnChange = (item, position) => {
    const updatedCheckedState = checkedState.map((isChecked, index) =>
      index === position ? !isChecked : isChecked
    );
    const data = {};
    data[item.id] = !checkedState[position];
    values[item.id] = !checkedState[position];
    setCheckedState(updatedCheckedState);
    const updatedUserData = allItems.filter((product, index) => updatedCheckedState[index]).map(product => product.name);

    //Total cost
    const selectedItems = allItems.filter((product, index) => updatedCheckedState[index]);
    const newTotalCost = selectedItems.reduce((total, product) => total + getPrice(product.name), 0);
    setTotalCost(newTotalCost);
    const isInsuranceSelected = !!newTotalCost;

    setValues({
      ...values,
      initialCost: newTotalCost,
      totalPrice: newTotalCost
    });
    dispatch(updateInsuranceAction({
      ...data,
      productList: updatedUserData,
      initialCost: newTotalCost,
      totalPrice: newTotalCost,
      isInsuranceSelected: isInsuranceSelected
    }));
  };

  const priceDisplay = classNames(
    {
      'combined_multiProduct_footer': !combinedPrice,
      'combined_singleFee_footer': combinedPrice
    }
  );

  return (
    <div>
      <div className="multiProduct_subtitle">
        <Text value={title} />
      </div>
      {allItems.map((item, index) => (
        <div key={item.name}>
          <div className={`multiProduct_container  ${checkedState[index] ? 'selected' : ''}`}
            onClick={() => handleOnChange(item, index)} >
            <div className="multiProduct_textSection">
              <div role="checkbox" className="checkbox_input">
                {checkedState[index] ?
                  <Icon icon="whiteCheckmarkIcon" /> : ''
                }
              </div>
              <label className="checkbox_text">{item.label}</label>
              <span className="border-divider"></span>
              <div className="multiProduct_price">
                <span>{Math.round(getPrice(item.name))}  </span>
                <Text value="$[units.$[paymentFrequency]]" />
              </div>
            </div>
            <div className="multiProduct_iconSection">
              <anchor-product-illustration name={item.icon} size={item.size}></anchor-product-illustration>
            </div>
          </div>
        </div>
      ))}
      <Label
        id="cancelDetails"
        label="${step-multiproduct-details}"
        variant="text"
        className="multiProduct_readMore"
        actions={[
          {
            actionType: "modal",
            props: {
              name: "productInformation",
            },
          },
        ]}
        dispatch={dispatch}
        userData={userData}
      />
      {(initialCost || combinedPrice) ?
        <div className={priceDisplay}>
          <div className='combined_accordion_footer'>
            {combinedPrice &&
              <div className="actualPrice_footer_text">
                <div><Text className="actualPrice_footer_details" value={commonFees} /></div>
                <div className="actualPrice_price_text">{bsFees} <Text value="$[units.$[paymentFrequency]]" /></div>
              </div>
            }
            <div className="totalprice_footer_text">
              <div><Text className="totalcost_footer_details" value={priceTitle} /></div>
              {combinedPrice &&
                <div className="footer_price_text">{combinedPrice && initialCost? Math.round(initialCost + 9.5): "--"} <Text value="$[units.$[paymentFrequency]]" /></div>
              }
              {!combinedPrice &&
                <div className="footer_price_text">{ Math.round(initialCost)} <Text value="$[units.$[paymentFrequency]]" /></div>
              }
            </div>
            {initialCost !== 0 && 
              <div>
                <Label
                  className="footer_button_main"
                  actions={priceBreakActions}
                  dispatch={dispatch}
                  label={priceDetails} />
              </div>
            }
          </div>
        </div> : ''
      }
    </div>
  );
}

Multiproduct.defaultProps = {
  options: [],
  title: "",
  combinedPrice: false,
  commonFees: "",
  bsFees: ""
}

Multiproduct.propTypes = {
  options: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  priceDetails: PropTypes.string,
  priceTitle: PropTypes.string,
  title: PropTypes.string,
  setValues: PropTypes.func.isRequired,
  priceBreakActions: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired,
  combinedPrice: PropTypes.bool,
  commonFees: PropTypes.string,
  bsFees: PropTypes.string
}